/**
 * US phone validation shared by client input and server-side Zod schemas.
 * Accepts any punctuation/spacing; validates on digit count only so that a
 * masked value like "(555) 123-4567" and a raw "5551234567" both pass.
 */

/** Digits only, dropping a leading US country code so 10- and 11-digit forms match. */
export function normalizeUsPhoneDigits(value: string): string {
  const digits = value.replace(/\D/g, '')
  if (digits.length === 11 && digits.startsWith('1')) return digits.slice(1)
  return digits
}

/** True for a valid 10-digit US number (with or without a leading "1"). */
export function isValidUsPhone(value: string): boolean {
  return normalizeUsPhoneDigits(value).length === 10
}

export const US_PHONE_ERROR = 'Enter a valid US phone number'
